<template>
  <div class="c-section grey">
    <div class="row">
      <div class="col">
        <p class="mb-0">
          <icon class="certificate"></icon>
          {{contentElement.linked_document.title + " " + contentElement.linked_document_id}}</p>
      </div>
      <div class="col-2">
        <button class="btn blue" disabled>
          View
        </button>
      </div>

    </div>

  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import ContentElementComponent from "./content-element-component.vue";

  export default Vue.extend({
    extends: ContentElementComponent,
  });
</script>